import React from 'react';

import {useUiConfig} from '../providers/UiConfigProvider';
import {usePartialIframe} from './OverlayOverrides';
import {Tooltip, TooltipLayerProps} from '../components/Tooltip';
import {tokens} from '@sail/tokens/deprecated';

export const useTooltipIframe = (props: TooltipLayerProps) => {
  const uiConfig = useUiConfig();
  const getUILayers = uiConfig?._unstable_getUILayers;

  const {triggerRef, ...remainingProps} = props;

  const containerStylesTypeDescription = {
    padding: 'medium',
    maxWidth: '300px',
    backgroundColor: 'surface',
    textColor: 'text',
  };
  const containerStylesTypeLabel = {
    paddingX: 'small',
    paddingY: 'xsmall',
    maxWidth: '200px',
    textColor: tokens.color.neutral[0],
    backgroundColor: tokens.color.neutral[700],
  };
  const containerStyles: React.ComponentProps<typeof Tooltip>['css'] = {
    font: 'body.small',
    ...(props.type === 'label'
      ? containerStylesTypeLabel
      : containerStylesTypeDescription),
  };

  return usePartialIframe({
    ...remainingProps,
    targetRef: triggerRef,
    containerStyles,
    uiLayers: getUILayers ? getUILayers() : [],
  });
};
